module.exports = __webpack_public_path__ + "static/media/profile.fcc68c72.svg";